import Mutations from '../../odata/mutations';

export default { ...new Mutations('subscription'), ...new Mutations('subscriptions') };
